import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Form } from 'react-bootstrap';
import { PolicyEntity } from "../../dto/policy/PolicyEntity";
import { PolicyModel } from "../../dto/policy/PolicyModel";
import { onPolicySubmit } from "../../controller/PolicyController";

const Policy = () => {
  const navigate = useNavigate();

  const policyActiveSelectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
        const prevState: PolicyEntity = {...policy.entity};
        if (policyActiveSelectRef.current !== null) {
            if (policyActiveSelectRef.current.value == 'true') {
                prevState.activeFlag = true;
            } else {
                prevState.activeFlag = false;
            }
            setPolicy({
                ...policy,
                entity: prevState
            });
        }
    }
  }, [])

  const entity: PolicyEntity = {
    id: undefined,
    type: '',
    activeFlag: undefined,
    text: ''
  }

  const [policy, setPolicy] = useState<PolicyModel>({
    action: 'create',
    entity: entity
  })

  const [validated, setValidated] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const handleReset = () => {
    if (formRef.current !== null) {
        formRef.current.reset();
    }
  }

  const [error, setError] = useState('');
  const policyFormValidate = async (event: React.FormEvent) => {
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
    } else {
        policySubmit(event);
    }
    setValidated(true);
  }

  const policySubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
        const response = await onPolicySubmit(policy);
        if (response !== undefined) {
            if (response.status === 0) {
                toast.success(response.msg);
            } else {
                toast.error(response.msg);
            }
        }
    } catch(e: any) {
        toast.error("Амжилтгүй");
    }
    handleReset();
    setValidated(false);
  }

  return (
    <Container fluid>
        <div><Toaster position="top-right"  reverseOrder={false}/></div>
        <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Үйлчилгээний нөхцөл</h3>
        <Form noValidate validated={validated} 
        onSubmit={policyFormValidate}
        ref={formRef}>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="policyType">
                        <Form.Label>Төрөл</Form.Label>
                        <Form.Control size="sm" type="text" 
                        onChange = {(event) => {
                            const prevState: PolicyEntity = {...policy.entity};
                            prevState.type = event.target.value;
                            setPolicy({
                                ...policy,
                                entity: prevState
                            })
                        }}
                        required />
                        <Form.Control.Feedback type="invalid">
                            Төрөл оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="categoryFreight">
                        <Form.Label>Идэвхтэй</Form.Label>
                        <Form.Select ref={policyActiveSelectRef}
                            size="sm"
                            onChange = {(event) => {
                                if (event.target.value == 'true') {
                                    const prevState: PolicyEntity = {...policy.entity};
                                    prevState.activeFlag = true;
                                    setPolicy({
                                        ...policy,
                                        entity: prevState
                                    })
                                } else {
                                    const prevState: PolicyEntity = {...policy.entity};
                                    prevState.activeFlag = false;
                                    setPolicy({
                                        ...policy,
                                        entity: prevState
                                    })
                                }
                            }}
                            required>
                            <option value="true">ТИЙМ</option>
                            <option value="false">ҮГҮЙ</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Төрөл сонгоно уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="policyText">
                        <Form.Label>Текст</Form.Label>
                        <Form.Control as="textarea" size="sm" rows={6}
                        onChange = {(event) => {
                            const prevState: PolicyEntity = {...policy.entity};
                            prevState.text = event.target.value;
                            setPolicy({
                                ...policy,
                                entity: prevState
                            })
                        }}
                        required />
                        <Form.Control.Feedback type="invalid">
                            Текст оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={3} md={3} lg={3}>
                    <Button size="sm" type="submit">
                        Хадгалах
                    </Button>
                </Col>
            </Row>
        </Form>
    </Container>
  )
}

export default Policy;